export type ThemeValue = 'light' | 'dark'

export function parseThemeParam(search: string): ThemeValue | null {
  const value = new URLSearchParams(search).get('theme')
  return value === 'dark' || value === 'light' ? value : null
}

// In-app WebView injects an EIP-1193 provider (App wallet bridge).
export function isInAppWebView(_nav: { userAgent?: string }, win: { ethereum?: unknown }): boolean {
  return Boolean(win?.ethereum)
}

// Used only when the user has NO stored/explicit preference.
export function resolveAutoTheme(input: {
  urlParam: ThemeValue | null
  inApp: boolean
  prefersDark: boolean
}): ThemeValue {
  if (input.urlParam) return input.urlParam
  if (input.inApp) return 'dark'
  return input.prefersDark ? 'dark' : 'light'
}
